<template>
  <div class="enroll-interview-score-edit">
    <el-popover
      @keydown.enter.native="updateScore"
      placement="top"
      width="200"
      v-model="visible">
      <el-form ref="form" label-width="70px">
        <el-form-item label="成绩：">
          <el-input v-model="score" size="mini" type="number" min="0"
                    @keydown.enter.native="updateScore" @keydown.esc.native="visible = false"></el-input>
        </el-form-item>
        <el-form-item label="结果：">
          <el-select v-model="result">
            <el-option label="通过" value="1"></el-option>
            <el-option label="不通过" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="updateScore" :loading="loading">确定</el-button>
      </div>
      <span slot="reference" class="data" :class="$attrs['cell-value'] === '1' ? 'grid-cell-success' : $attrs['cell-value'] === '0' ? 'grid-cell-danger' : 'grid-cell-empty'">
        {{$attrs['cell-value'] === '1' ? '通过' : $attrs['cell-value'] === '0' ? '不通过' : '未设置'}}
        <span class="icon"><i class="el-icon-edit"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EnrollInterviewScoreEdit',
  data () {
    return {
      visible: false,
      score: null,
      result: null,
      loading: false
    }
  },
  created () {
    this.result = this.$attrs['cell-value']
    this.score = this.$attrs['row-data'].interviewScore
  },
  activated () {
    this.result = this.$attrs['cell-value']
    this.score = this.$attrs['row-data'].interviewScore
  },
  methods: {
    updateScore () {
      if (this.score === '' || isNaN(this.score)) {
        this.$message.warning('请输入0-100内的分值，最大两位小数')
        return false
      }
      const r = /^(([1-9]?\d{0,1}(\.\d{1,2})?)|100)$/
      if (!r.test(this.score)) {
        this.$message.warning('请输入0-100内的分值，最大两位小数')
        return false
      }
      if (!this.result) {
        this.$message.warning('请选择面试结果')
        return false
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/interview/score/edit',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.$attrs['row-data'].id,
          score: this.score,
          result: this.result
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('reloadGridData')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../../../styles/color';
.enroll-interview-score-edit {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  .data{
    cursor: pointer;
    .icon{
      color: $set-primary-color;
      margin-left: 5px;
    }
  }
}
</style>
